<template>
	<div class="SocialmediaCronWorksGroup">
		<div class="GroupHeader">
			<div class="day">{{group.day}}</div>
			<div class="weekday">{{group.weekday}}</div>
		</div>
		<div class="GroupBody">
			<GroupItem v-for="(item,itemIndex) in group.items" :key="itemIndex" 
			:brands="brands" 
			:item="item" 
			v-on:editItem="editItem($event)"
			/>
		</div>
	</div>
</template>


<script>
	import GroupItem from "./GroupItem"
	export default {
		name : "SocialmediaCronWorksGroup",
		components : {
			GroupItem
		},
		props : ["group","brands"],
		methods : {
			editItem(id){
				this.$emit("editItem", id);
			}
		}
	}
</script>


<style lang="less">
	.SocialmediaCronWorksGroup{
		margin-left: 10px;
		margin-right: 10px;
		margin-bottom: 30px;
		.GroupHeader{
			background-color: #404041;
			color: #fff;
			text-align: center;
			padding: 2px 0;
			margin-bottom:15px;
			.day{
				font-size:13px;
			}
			.weekday{
				font-size:11px;
				margin-top: -2px;
				color : #999;
			}
		}
		.GroupBody{

		}
	}
</style>
